import { render, staticRenderFns } from "./listaRecintos2.vue?vue&type=template&id=b36e2558&"
import script from "./listaRecintos2.vue?vue&type=script&lang=js&"
export * from "./listaRecintos2.vue?vue&type=script&lang=js&"
import style0 from "./listaRecintos2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "listaRecintos2.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VContainer,
  VFlex,
  VImg,
  VLayout,
  VProgressCircular,
})
